<form *ngIf="offerLetter.legalFirstName" autocomplete="nope" #form="ngForm">
    <ui-banner *ngIf="!offerLetterHasCosigners" variant="info">
        <p>{{ 'offer-letter.infoCandidateReceivesEmail' | translate }}</p>
    </ui-banner>

    <ui-banner *ngIf="offerLetterHasCosigners" variant="info">
        <p>{{ 'offer-letter.cosignerSendText' | translate }}</p>
    </ui-banner>

    <!-- Candidate Information -->
    <h3>{{ 'offer-letter.candidateInformation' | translate }}</h3>

    <div class="entity app-grid margin-bottom-1">
        <label class="columns-3">{{ 'offer-letter.legalFirstName' | translate }}</label>
        <label class="columns-3">{{ 'offer-letter.legalLastName' | translate }}</label>
    </div>

    <div class="app-grid margin-bottom-3">
        <span class="columns-3 value-color">{{ offerLetter.legalFirstName }}</span>
        <span class="columns-3 value-color">{{ offerLetter.legalLastName }}</span>
    </div>

    <div class="entity app-grid margin-bottom-1">
        <label class="columns-3">{{ 'offer-letter.emailAddress' | translate }}</label>
        <label class="columns-3">{{ 'offer-letter.reportsTo' | translate }}</label>
    </div>

    <div class="app-grid margin-bottom-3">
        <span class="columns-3 value-color">{{ offerLetter.email }}</span>
        <span class="columns-3 value-color">{{
            offerLetter.reportsTo ? offerLetter.reportsTo.fullName : ('none' | translate)
        }}</span>
    </div>

    <hr />

    <!-- Letter Template -->
    <h3>{{ 'offer-letter.letterTemplate' | translate }}</h3>

    <div class="entity app-grid margin-y-3">
        <label class="columns-4 small-columns-12">{{ 'offer-letter.offerLetterTemplate' | translate }}</label>
        <span class="value-color">{{ offerLetter?.signingTemplate?.document?.name }}</span>
    </div>

    <!-- Letter Template -->
    <ng-container *ngIf="offerLetterHasCosigners">
        <hr />

        <h3>{{ 'offer-letter.cosigners' | translate }}</h3>
        <div class="entity app-grid margin-y-3">
            <ng-container *ngFor="let item of offerLetter.signingTemplate.slots; let isFirst = first">
                <div *ngIf="item.name !== signingTemplateSlotNames.Candidate" [ngClass]="{ 'margin-top-3': !isFirst }">
                    <label class="columns-4 small-columns-12">{{
                        item?.name | appTranslateOptions: templateSlotNamesDisplayOptions
                    }}</label>

                    <div *ngIf="item.assignee" class="value-color">
                        {{ item.assignee.fullName }}
                        <span>({{ item.assignee.job?.title }})</span>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <hr />

    <!-- Letter Details -->
    <div class="flex justify-space-between align-items-center">
        <h3 class="margin-bottom-0">{{ 'offer-letter.letterDetails' | translate }}</h3>
    </div>

    <ng-container *ngFor="let formInputAttribute of mergeFieldFormInputAttributes">
        <div class="app-grid" [ngSwitch]="formInputAttribute.inputType">
            <!-- Date Field -->
            <ng-container *ngSwitchCase="mergeFieldFormInputTypes.date">
                <div class="entity app-grid margin-y-2">
                    <label class="columns-4 small-columns-6">{{ formInputAttribute.label | translate }}</label>
                    <span *ngIf="offerLetter[formInputAttribute.attributeName]" class="value-color">{{
                        offerLetter[formInputAttribute.attributeName] | appDate
                    }}</span>
                    <!-- show a dash if null date -->
                    <span *ngIf="!offerLetter[formInputAttribute.attributeName]" class="value-color">-</span>
                </div>
            </ng-container>

            <!-- Dropdown Field -->
            <ng-container *ngSwitchCase="mergeFieldFormInputTypes.dropdown">
                <div class="entity app-grid margin-y-2">
                    <label class="columns-4 small-columns-6">{{ formInputAttribute.label | translate }}</label>
                    <!-- show a dash if null value -->
                    <span *ngIf="!offerLetter[formInputAttribute.attributeName]" class="value-color">-</span>

                    <ng-container *ngIf="offerLetter[formInputAttribute.attributeName]">
                        <!-- If there's an option label - for example department, location, position -->
                        <ng-container *ngIf="formInputAttribute.dropDownOptions?.optionLabel">
                            <span class="value-color"> {{ getDropdownOptionLabel(formInputAttribute) }} </span>
                        </ng-container>
                        <!-- If there's no  option label - for example employment type, compensation type -->
                        <ng-container *ngIf="!formInputAttribute.dropDownOptions?.optionLabel">
                            <span class="value-color">
                                {{
                                    'offer-letter.merge-fields.dropdown-options.' +
                                        offerLetter[formInputAttribute.attributeName] | translate
                                }}
                            </span>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>

            <!-- Default -->
            <ng-container *ngSwitchDefault>
                <div class="entity app-grid margin-y-2">
                    <label class="columns-4 small-columns-6">{{ formInputAttribute.label | translate }}</label>
                    <span *ngIf="offerLetter[formInputAttribute.attributeName]" class="value-color">{{
                        offerLetter[formInputAttribute.attributeName] | maybeCurrency
                    }}</span>
                    <!-- show a dash if null date -->
                    <span *ngIf="!offerLetter[formInputAttribute.attributeName]" class="value-color">-</span>
                </div>
            </ng-container>
        </div>
    </ng-container>
</form>
